import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
import { Galleria } from "primereact/galleria";
// components
import NumberInput from "../../../../components/input/NumberInput";
import Modal from "../../../../components/modal/Modal";

const IbCashShop = () => {
  const [Visible, setVisible] = useState(false);
  const [content, setContent] = useState(1);
  const [item, setItem] = useState("");
  const [balanceIb] = useState(16.7);
  const [activeIndex, setActiveIndex] = useState(0);
  const [images, setImages] = useState(null);

  const PhotoService = {
    getData() {
      return [
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria1.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria1s.jpg",
          alt: "Description for Image 1",
          title: "Title 1",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria2.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria2s.jpg",
          alt: "Description for Image 2",
          title: "Title 2",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria3.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria3s.jpg",
          alt: "Description for Image 3",
          title: "Title 3",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria4.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria4s.jpg",
          alt: "Description for Image 4",
          title: "Title 4",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria5.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria5s.jpg",
          alt: "Description for Image 5",
          title: "Title 5",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria6.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria6s.jpg",
          alt: "Description for Image 6",
          title: "Title 6",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria7.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria7s.jpg",
          alt: "Description for Image 7",
          title: "Title 7",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria8.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria8s.jpg",
          alt: "Description for Image 8",
          title: "Title 8",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria9.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria9s.jpg",
          alt: "Description for Image 9",
          title: "Title 9",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria10.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria10s.jpg",
          alt: "Description for Image 10",
          title: "Title 10",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria11.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria11s.jpg",
          alt: "Description for Image 11",
          title: "Title 11",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria12.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria12s.jpg",
          alt: "Description for Image 12",
          title: "Title 12",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria13.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria13s.jpg",
          alt: "Description for Image 13",
          title: "Title 13",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria14.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria14s.jpg",
          alt: "Description for Image 14",
          title: "Title 14",
        },
        {
          itemImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria15.jpg",
          thumbnailImageSrc:
            "https://primefaces.org/cdn/primereact/images/galleria/galleria15s.jpg",
          alt: "Description for Image 15",
          title: "Title 15",
        },
      ];
    },

    getImages() {
      return Promise.resolve(this.getData());
    },
  };

  // const PhotoService = useMemo(
  //   () => [
  //     {
  //       getData() {
  //         return [
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria1.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria1s.jpg",
  //             alt: "Description for Image 1",
  //             title: "Title 1",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria2.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria2s.jpg",
  //             alt: "Description for Image 2",
  //             title: "Title 2",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria3.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria3s.jpg",
  //             alt: "Description for Image 3",
  //             title: "Title 3",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria4.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria4s.jpg",
  //             alt: "Description for Image 4",
  //             title: "Title 4",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria5.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria5s.jpg",
  //             alt: "Description for Image 5",
  //             title: "Title 5",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria6.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria6s.jpg",
  //             alt: "Description for Image 6",
  //             title: "Title 6",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria7.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria7s.jpg",
  //             alt: "Description for Image 7",
  //             title: "Title 7",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria8.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria8s.jpg",
  //             alt: "Description for Image 8",
  //             title: "Title 8",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria9.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria9s.jpg",
  //             alt: "Description for Image 9",
  //             title: "Title 9",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria10.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria10s.jpg",
  //             alt: "Description for Image 10",
  //             title: "Title 10",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria11.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria11s.jpg",
  //             alt: "Description for Image 11",
  //             title: "Title 11",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria12.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria12s.jpg",
  //             alt: "Description for Image 12",
  //             title: "Title 12",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria13.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria13s.jpg",
  //             alt: "Description for Image 13",
  //             title: "Title 13",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria14.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria14s.jpg",
  //             alt: "Description for Image 14",
  //             title: "Title 14",
  //           },
  //           {
  //             itemImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria15.jpg",
  //             thumbnailImageSrc:
  //               "https://primefaces.org/cdn/primereact/images/galleria/galleria15s.jpg",
  //             alt: "Description for Image 15",
  //             title: "Title 15",
  //           },
  //         ];
  //       },

  //       getImages() {
  //         const images = Promise.resolve(this.getData());
  //         setImages(images)
  //       },
  //     },
  //   ],
  //   []
  // );

  const responsiveOptions = [
    {
      breakpoint: "991px",
      numVisible: 4,
    },
    {
      breakpoint: "767px",
      numVisible: 3,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
    },
  ];

  useEffect(() => {
    PhotoService.getImages().then((data) => setImages(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const itemTemplate = (item) => {
    return (
      <img
        src={item.itemImageSrc}
        alt={item.alt}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={item.thumbnailImageSrc}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  const form = useForm();
  const errors = form.formState.errors;
  const items = [
    {
      title: "Iphone 14 Pro",
      desc: "Lançamento Iphone 14 Pro 128gb",
      price: 5999.9,
      priceIb: 14999.75,
      image:
        "data:image/jpeg;base64,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",
    },
    {
      title: "Iphone 13 Pro",
      desc: "Lançamento Iphone 13 Pro 128gb",
      price: 5694.15,
      priceIb: 14235.37,
      image:
        "https://trocafone.vtexassets.com/arquivos/ids/254184/iphone-13-pro-prateado.jpg?v=638138870283870000",
    },
    {
      title: "Apple Mackbook Air M2",
      desc: "Tela 13,6' M2 8GB RAM 256gb",
      price: 10173.74,
      priceIb: 25434.35,
      image:
        "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-midnight-select-20220606?wid=904&hei=840&fmt=jpeg&qlt=90&.v=1653084303665",
    },
    {
      title: "Apple Mackbook Air M1",
      desc: "Processador M1 8GB RAM 256gb",
      price: 7700,
      priceIb: 19250.0,
      image:
        "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-space-gray-select-201810?wid=904&hei=840&fmt=jpeg&qlt=90&.v=1664472289661",
    },
    {
      title: "Apple ipad mini (6° geração)",
      desc: "A15 Bionic (8,3', Wi-fi, 64GB)",
      price: 3837.75,
      priceIb: 9594.38,
      image:
        "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBIVEhgSFRQYGBgYGRgaGhgZGBgYGhgaGBgaGRoYGBgcIy4lHCErIRgYJjgrLDAxNTU1GiU7QDs0Py40NTEBDAwMEA8QHhISHzErJSc0NjY0OjQ2NDo7NTQ0NDQ0NDY0MTY0NDQ0NDQxNDE0NDc9PzY0NDQ0MTE0PTQ0NDQ0NP/AABEIAOEA4QMBIgACEQEDEQH/xAAcAAEAAgMBAQEAAAAAAAAAAAAABQcEBggDAgH/xABFEAACAQIBBgkICAUEAwEAAAABAgADEQQFBhIhMXEHEyIyQVFhgZEjQlJykqGxshQWNVRig9HSF5OiweEzc4LwU2PCFf/EABoBAQADAQEBAAAAAAAAAAAAAAACAwQBBQb/xAAqEQACAQMDBAICAQUAAAAAAAAAAQIDESEEEjETQVFhBSIycRQjgZGhwf/aAAwDAQACEQMRAD8AuaIiAIiIAiIgCIiAIiIAiIgCIiAIiIAiIgCIiAIiIAiIgCIiAIiIAiIgCIiAIiIAiJ8VHsIB9xMN6pPTbdq988qlYqLknxM5c7YkYlS528KP0aq1GgvGVF1MWNkQ+ieliOm1rdd7iakeGHKd76ND2H/fOnDoeJzv/GHKnVQ/lv8Avj+MOVNujQ/lv++AdEROef4x5U9HD/y2/fH8Y8qejh/5bfvgHQ0Tnj+MeVPRw/8ALb98+24YMqC2rDm//rb98A6Eic8/xjyp6OH/AJbfvj+MeVPRw/8ALb98A6Gic8/xjyp6OH/lt++fJ4YMqHzaHcjj4PAOiInO38YMqdVD2Kn75lYHhlx6t5SlRdekAOjdzFmt4QC/4kDmnnPQyhQ46jcEGzo3OQ9R/WT0AREQBERAEREAREQBERAExcQdcypiYjnTjOo5/wCEDOLFtj6lPj3opTC6CozoDdVNzo7Tcnbstabxmbl6vWyZxlYlmQPyjtcKWsT1823dNiyzmjg8S4qVaQZr7bDrv4XJNtm3VPnKuBp0MI9OmoVQj6gANiEDZ2C043g7Y5tVi9S7Eks12J2kk3J3ycwGRDWfQpUizdQJ1DrJJsBvkHg+eu+XbwfYRFwYqAcp3YsenksVUbgBfvMzaqq6cbovoQUnk0HGZj4immmaOkALnQfSKjtUG/heQf0On6PvP6zoDQlWZWyI1TKdXDUAANJWPQqBkVnJt0AudQ6wJloaqU73fBonQiuDUvoVP0fef1j6FT9H3n9ZZX8PaWhbj307bdFdC/qbf6pB4/MnF07lAtVfwGzd6tb3EyyOpUuJEXQa7Go/Qqfo+8/rH0Kn6PvP6zMxFB0bRdGRuplKnwM85Z1JeSGxeDH+hU/R95/WS+EzPrVFDrRspFwWbRvuBN585Ipq2Ipq3NLrcdevYd5sO+WWMRM2p1U6dku5ooaeM02yqcbkNqJtUosvUTex3MDYzF+hU+r3n9ZcwZHUq4DKdoIBB3gzW8s5mowNTDnRbbxZPJPqseaew6t0jS1u7EnZiel25WSvfoVP0fef1nhjMKoUsosRbpPXbpklWpMjFHUqymxUixB7RMTH/wCm3d8RNsJyclkyzgrPBufAVi2XKFSkDyalFiR+JGXRPgzeMv8AnO/Af9qH/YqfMk6ImsyiIiAIiIAiIgCIiAIiIAmHiOd3TMmFiud3TjOo8iJD5ynyD+o/yNJe8h85T5B/Uf5GkSRzLg+eu+WFmlnScJpU3UvSY6VltpI1rErfUb2Fxq2eNe4Pnrvk/Qou7hEVnZjYKoLEnsAlGoSeGW0W0iysfn/hQnkkd3I1BlCqD+I3v4CQuYeUtPGVWqNd6y3BPSwbSKju2DqWYuGzAx7KGK00v0O+sdyBh74r5iZRTlIqORrHF1AGBHSNILrmLbSUXFNZ9mlSd02WbeLyuFzkylhTo4mkzAavKoUJ9WoBZt+uTmAz5wr6qgakesjTT2l1+IEyS0045Wf0aFVizZsRh0ddF0V16mUMPAzW8oZkYR7lNKk34TpL7Lf2ImwYbF06i6VN1detGDDvtsntKlUqU3zYm4xlyVljsy8XSOkmjVA1godFxbp0Wt7iZ9UcvOhCYim6MNpKkHeUOsd0sqeWIw6Oui6K46mUMPAy16lTVqkbnIwcXeLNYwWOVgGVgw6wf+2kvh688vq3hQ2kilG/AzAHsKm6+6ZdLAouwk75nm43+pem2s8kXnHkJMTT0lAFVRyG2aX4G7OrqPfKoyipCMCLEGxB2ghtYMvO1pUuf1FUxNYL52g1u1gpPvue+ehoKrctrMWrglHciQ4D/tQ/7FT5knRE534D/tX8ip8yToie0eUIiIAiIgCIiAIiIAiIgH5MLF87umbMDGc7unHwdR5XkPnIfIP6j/I0lbyIzjPkX9R/kaRJHNOD5675dfBpk1Ew5xJAL1GZQelUU6OiOq5BJ7uqUpg+eu+XJwcZUU0Wwx56MWUdJRzfV12a/iJi1+7Zgv09u5vyz6AmBWxZQXZSN4IHjMdcuoNTKw7RrnkR9mqzfBLOgIIIBB2g6wd4mv5SzMwNa54rQY+dTOh/SOSfCSuGypQdtBailvRvZrdeiddu2ZgMtUpR4diLRWmN4PMTSbjMLXDEbASab26g66j/AEzBbL+U8GQuJpkr11FtfsWqvJJ8Zbc/HUEFSAQdoIuDvHTLOvuxOKZxXXDNAydnthalg+lSb8XKXuYf3Amw0MSji6MrD8JBmPlTMnA1bkU+Kb0qR0B7HN901ivmZjMOdLD1FqqNei3Ifuvqv3iQlSpT/B2fhl0KzXKNzJnwxmq4XFYhToPxiN6Lg/0k6mHaJLUjVba58B+kyTg4uzNUZJq5kY/H06KGo7BVHiT1KOk9kqDOPGGs1SqRbTYG3UBYKO4ASycuZvcfTOvlqCUYnp9E9hlW5SQhWUixBsQdoINiDPS+PjHlc9zFq5Nq3Y2ngQ+1fyKnzJOiJzvwIfav5FT5knRE9o8sREQBERAEREAREQBERAPyR+NPK7pISNx/O7pF8HUeN5D5xHyL+o/yNJW8iM4T5F/Uf5GkSRzZg+eu+X3wVZKprg/pWiDUqs40ulURioQHoBKknruOoShMJz13yz8w89Bg1NCsrNRZiysutqbHncnzlNr9YN9t5XXipYZ2O7a7FylBI7FZFoPtQA9a8k+7Ue+eWTM58DibCliELHzGOg/sNYyYtMUtImcVeUXnBpeVsy1qLYMGG0BhYg9auNh7prWJoZYwOtHepTHmuONAG/bbcRuls2nyVlUaU6eFleGXrU7uSscl8JVM8nE0WQ7C6HSHejWYd15uOTct4XEDyNZHPo3s43obMPCfeWM1cFiddWgul6aXR+9ltpbjcTScqcFrjlYbEXtrC1RY9zoP/kTsoU5emSVQsEmfDSrHx+WsB/qq7IOmoONS3+4p0l72G6S+TeEei9hXpuh9JOWm+2ph4GVS00lmOS2M0bu6gixFx1GeH0ZBrCgbtXumPgcsYauPJVkfsDDS71OseEzGmacWsNF8X4PB1EpvhBoKmKrBfO0Gt2sqk+Jue+WtljK9HDoXqMB6KDnuepV/vsEpbOHGtXapWbazA26hcAKNwAHdNfx9OSnu7FWpktlu5sPAh9qfkVPmSdEznbgQ+1fyanxSdEz3DzBERAEREAREQBERAEREA/JG4/nd0kpGZQ53cJF8HUYt5EZwnyL+o/yNJUmRGcJ8i/qP8jSJI5wwnPXfLGzKzMbHaVR2NOih0SygF3a1yqaQsLXFyQdtrdVc4Tnrvl/8FWNRsnikCNOnUcOOnlsXVtxBt/xMk4qUkiudRwg2jGyjwW4RktRqVEcDUXKujH8Y0QRvBG3YZoFDLmUcDUeitd0amxVkY8YgKnYFe4t2i2oy/g0qQ5Ip5Ty3ibN5BCpcqdb6CJS0VPRpOjax0Kbbbzk6drWK6FdyT3ZSMjJXCtUFlxOHDdb0Ton2HJB9obpu2Sc8MBibKldVc+Y/Ie/UA2pu4mfpzSycU0PodG3XoANv0+dftvNYytwW4d7nD1mpH0HHGJuBNmG8lt0i6TOKtSk+6LEtEps5Ny7k7XTZ3pr/AOM8dTsP/Ww0l7lG+SWSeFZgdDFYe9tRekbEHtpuf/rulMqafKLVe14u5aJE13K+ZeAxFy9EI58+nyGv1m3JY+sDMvJGc+CxNuJroWPmNyH9hrE90mLSl0XHMcElWawypMrcF9dOVhqq1ANiuNB+5hySfZmqY5coYY6FVsRS6Bd3CnsVgdE9xnQ0861FXUq6hlO1WAIO8HbIb5R/JXLo1Ezmh6hYlmJYnaSSSd5MxsdzG7vjLuy3wcYOsC1G+Hfo0NaE9tM7B6pWUzl/A1KDVKFQWem2iw2jaCCD0gggjsMvpTjJqx2TwzY+BH7V/JqfFJ0TOduBD7V/JqfFJ0TNpnEREAREQBERAEREAREQD8kVlI8ruElZE5UPK7h/eRfB1GGTIjOA+Sf1H+RpKEyIy+fJP6j/ACNIkjnbCc9d82PJmUq2GqcZRdkfZcbCOplOphvmuYTnrvmw5OyfVruKdJC7HuAHSzE6gIkm5KxxOKi93BNY/PjKFZDTaqEUizaCBGYdN2Gsd1pkcHOX6eExTcadGnVUIW6EYG6s3Uu0E9FwdgktgeDUlQa2JsfRppcD/m+32RMivwY07cjEuD+NFYf0lZZ0at7szPUaezinh+EWhSqK6h1YMp2MpDA7iJ9ymDmhlXCMXw1TS138jUKE9rI9lbdypl4PhGx+Hbi8XQD29JTRqb9mi3sjfOttfkrFPRUswkmW7InK+b2ExI8vQRz6dtFxudbN75FZIz+yfXspqGix82sNAdWp7lTuvfsm0KwIuDcHYRrB3GSVpFTU4Puissr8Fh1vhMRr2hK39qijV3qd8jqOVsr5OIXELUFMecw42nb1hcAbiD2S358nZb3R012J/wAltWkrmqZHz4SooNRLX89DpL7J1j3zacLi6dQXRg246xvB1iQmJzYwjMXWmKbHaafIDHrZBySe2155U8jBDdXOrZqsfETktPGS8EFqHF4yjZ5z1wk5Qp18bXqUyCgKIGGxiiqrMOsXBAPUBLkxFRyuiXYjf8euUhnphBSxFZFFl0lYDqDgNbxJHdKP4+xpmuhqFUbXol+BH7V/JqfFJ0TOduBH7V/JqfFJ0TLS8REQBERAEREAREQBERAPyQ+VTyxuH95MSFyweWPVHxMi+DqMAmReXT5J/Uf5GkiWkVls+Tf1H+RpAkc94Xnrvl0cG+FRMLxluVUdrnpshKqN2onvlL4bnrvlqcHmV1FNsMx5Skunarc4Dcdf/KaqFuormPW7ui7ec/ostZ9iRLZQsNVphPluovQrdhBHvE3uDPE6sTZBPPFYWnVXQqIjqfNdQw8DNYpZ8UFbRxCPRJ2NbTptuddfiomyYHHUqy6dKojr6SMGG422GUuzwX7ZRV/9mqZW4OMJUu1FmoN1Dlp7LG47iJrByPljJp0qDOyA38kTUp2v51Ei47SF1dctyLyqVFPKwWw1dSOJZXsr7InCjeyYqkAdhensv2ox1eM3vJ+W8NXF6VVWJ829m9k65H5YzcwmJ11aKlvTXkP7a6z33moYnMOvROlhawddvF1eSf8Ai6i1+4SKjKPOSUqlKa+uH4fBZbmYlRppmExeMpABxUXoKvZxuD61PcZK0so1WGvR8D+suUG+DJKajhmdi6iqpZiAoBJJNgANpJ6JR+deUBiK1WqvNYgL6q2UHvtfvlk515Nq4igVVmDLyggNle3msOnsvsMqTGc1v+9MzV9yaTPS0Cg05J54Nu4EftX8mp8UnRM514EftX8mp8VnRUrN4iIgCIiAIiIAiIgCIiAfkgstnyg9UfEydkBl0+UHqj4mRfB1EcTIvLZ8m/qP8jSQLSNyyfJv6j/I0giRQGG5675YWYmQuOqfSHLBKbWUKbF3tr1+iAdfXe3XK9w3PXfLjzBrqMGoG0O99+kT8CJroRUp5MWsqSjSdu+DdKVJQNQAnzVwtNucqnuF/GErrbWQN5nqpB1g33Tc7nhWViDx+bFCoCBdb9HOXwOv3zTcfmRjKD8bhnJI2FHKOBtsNYPRsuZZ8/ZXOClyW0q8qXH+CrsBn9jsO/F4lOMttDrxdQDruBY966+ubtkjPbA4iy8ZxbnzKtk19QfmnxkjjsBRrroVaaVF6nUG3ap2g9omnZV4OqLXbD1Gpn0Hu6bgecO+8ocKkeHdGpVaFX8lZ+uCw7z8JlN8XlbJutS4pj0TxtG3ap5u+yntk9krhMU2XE0bfjpG43lGNwNxM6qi4krEZ6STV4NNeixTPD6LTvcIBuFvcJg5NzhwmItxVdGJ80nRf2GsfdJFjLYtPgxzi4u0keVWiLSkM/sKtPF1lXYSj26i6qze+575cWV8q0sOheq4UdA85j1Ku0mUbnFj2xFSpXYWLsDbqAsqjuUCUV5KyXc9D46nLc5drGxcCP2r+TU+Kzoqc68CP2r+TU+KzoqZz1hERAEREAREQBERAEREA/JrmcB8oPVHxM2Oa1nGfKj1B8TIy4OrkjC0jsrnybeo/wAjTN0pH5WPk29R/kaQRIoXDc9d83HNfLHEVCjGyPbX0K2wHcdh7pp2G5675umbGTUc8Y40gDZVOwkbSR0zTRUnNWMmqlCNJufBvH0hmGq53TGelXGtA4PWhIPuN5IYYiSNKetY+cdW3Y1GpnLlDDm7gVU9Goug47FdQL94YyYyXwgYOpyagai34uUntrsHrASfCAixAI6jrkJlXM3CV7sENJz59Oy39ZOafAHtmadOSzF/2NVKtSmrVFb2v+mzUK6OodHV1OxlIYHvE+zKgypkLG5OPHU6p4u4HGUyVsTqHGJ7tdxJDJXCLWWy4mmKg9NLI/evNY+zK1Ws7SVi6Wico7qTTRZhmu5XzSwde7FNBz59OyEnrZea28i/bMzJWcWExOqlVGl6Dch/ZO3uvJNpalCa8mNupReLplUZWzGxVK7U7VkHo8lxvQ7e4mQSZRxVO9MVqyW1FA7pbsK3Fpd7yLypkmhiBarTVuptjDc41iVz0t8xdjTT+UccVY3XlFN1arOdJ2Zm9JmLHxOuY2K5h7vjN3ytmMy3bDvpjboPYPuDDU3eBNIxqkKwIIINiDqIINiCJknTnB/ZHsafU0qsb02bdwI/av5NT4rOipzrwI/av5NT4rOipAuEREAREQBERAEREAREQD8mr5ynyo9QfEzaJq2dAtVU9afAn9RIvg6uSIvMDKp8m3qP8jTLvMTKCllKjawZRvZSo95EgSKJw3PG+bvm5igE0elSdXYTe80ai1mBPXJWnX0TpK9j1gzTSqbJXMupo9aG0sujlFFF2M9Fztwimzsy9uixH9NzK8//AGHtYlT23/tMOpX0jcsL7xNUtUkvqebT+Mbf9Tj0XbkzK2Hrf6VVHPohhpDep1jwkpOfBUAIIYAjYb6xuM2TJOfOLoDRZlrL0CoSWG5wb+N5yOqT5R2fxjivo7/stPLAT6NW07aPFvpX6tAyiV2Sfy/njXxScW2giXBKITyraxpsdo7NU1/TXrHjKK01N4NujoSoxalyz9mxZJzxxdCyluNQebUuxt+FucO+47JrmmvWPGNNeseMqjJxd0aJ04TVpK5bGSs9sJWsrE0X6nI0Cfwvs8bTYCQdY1g7D1yhtNeseMksl5wV8P8A6VWy+gx0lP8AxOzutNVPVNYkjy9R8XGWabt6ZcbiVFn3o/S62j+C/raK6X/eu8lcRn/XZNFUpoxHOBLW7VUmw77zTsdX0gxLaTMbk3uSSbkmd1FaM0kh8foZ0JuUvFjcOBL7VH+zU+Kzoqc9cB9FjlMsBqWi9z1XZQP7+E6FmM9cREQBERAEREAREQBERAEjcr5P45LA2Ya1PR2g9hklEA0Ktk+sps1N94BI8RqmNXwdRltoP7LfpLFiQ2krnOuceYuJao1WhSblElqZUryidZRiNGx1mxIt0X6ID6k5T+51fAH+86pn7JIicqfUnKf3Or7P+Y+pOU/udX2f8zquJ0HKn1Jyn9zq+z/mPqTlP7nV9n/M6riAcqfUnKf3Or7P+Y+pOU/udX2f8zquIByp9Scp/c6vs/5j6k5T+51fZ/zOq4gHKn1Jyn9zq+z/AJj6k5T+51fZnVcQDlT6k5T+51fZmTg+D7KtRgowjrfznsqjtJJnUUQDTODvMtcnUW0iGrVLF2GwAbFHYLmbnEQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQBERAEREAREQD//Z",
    },
  ];

  const formatPrice = (price) => {
    return price.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const formatIbCash = (price) => {
    return `IBC ${price
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&.")
      .replace(".", ",")}`;
  };

  const onSubmit = (data) => {
//    console.log(data);
  };

  const clickLoot = () => {
    setContent(1);
    setItem("");
    setVisible(true);
  };

  const clickItems = (item) => {
    setContent(2);
    setItem(item);
    setVisible(true);
  };

  return (
    <>
      <div className="col-md-4 text-center">
        <h2 className="bg-white p-3 rounded-pill balance-cash">
          Saldo Ib Cash: <span className="text-success">IBC {balanceIb}</span>
        </h2>
      </div>
      <div className="row mt-3">
        <div className="col-md-4 my-2 card-shop" onClick={() => clickLoot()}>
          <div className="rounded text-center bg-white p-4 h-100 d-flex flex-column align-items-center justify-content-center child-card-shop">
            <i
              className="fa-solid fa-sack-dollar mb-3 text-success"
              style={{ fontSize: "90px" }}
            ></i>
            <h4>Saque em Moeda Corrente</h4>
            <h5 className="text-secondary">Converta IBC para moeda corrente</h5>
            <h4 className="text-success">IBC</h4>
          </div>
        </div>
        {items.map((i, index) => {
          return (
            <div
              key={index}
              className="col-md-4 my-2 card-shop"
              onClick={() => clickItems(i)}
            >
              <div className="rounded text-center bg-white p-4 h-100 d-flex flex-column align-items-center justify-content-center child-card-shop">
                <div className="d-flex justify-content-center my-2">
                  <img className="image-shop" src={i.image} alt="" />
                </div>
                <h4>{i.title}</h4>
                <h5 className="text-secondary">{i.desc}</h5>
                <h4 className="text-success">{formatPrice(i.price)}</h4>
              </div>
            </div>
          );
        })}
      </div>
      <Modal
        visible={Visible}
        position="center"
        onHide={() => setVisible(false)}
        dynamicTitle="Solicitar Saque"
      >
        {content === 1 ? (
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <h3 className="">Saldo disponível</h3>
              <h1 className="text-success">IBC {balanceIb}</h1>
              <div
                className={
                  window.innerWidth <= 992
                    ? "mt-3 d-flex flex-column align-items-center"
                    : "mt-3 d-flex align-items-center"
                }
              >
                <div className="mt-2 d-flex flex-column align-items-center">
                  <h5>Valor que deseja sacar:</h5>
                  <NumberInput
                    name="value"
                    prefix={"IBC "}
                    placeholder={0}
                    defaultValue={0}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    control={form.control}
                    errors={errors}
                  />
                </div>
                <i
                  className="fa-solid fa-equals mx-4"
                  style={{ fontSize: "30px", marginTop: "30px" }}
                ></i>
                <div className="d-flex flex-column align-items-center">
                  <h5 className="mt-3">Total a Receber:</h5>
                  <h1 className="text-success">R$ 20,75</h1>
                </div>
              </div>
              <Button
                rounded
                type="submit"
                iconPos="left"
                label="Solicitar Saque"
                icon="fa-solid fa-circle-dollar-to-slot"
                className="p-inputtext-sm m-auto mt-4"
              />
            </div>
          </form>
        ) : (
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-6">
                <div className="d-flex justify-content-center my-2">
                  <Galleria
                    value={images}
                    activeIndex={activeIndex}
                    onItemChange={(e) => setActiveIndex(e.index)}
                    responsiveOptions={responsiveOptions}
                    numVisible={5}
                    item={itemTemplate}
                    thumbnail={thumbnailTemplate}
                    className="w-100"
                    // style={{ maxWidth: '250px' }}
                  />
                  {/* <img className='image-shop' src={item.image} alt="" /> */}
                </div>
              </div>
              <div className="col-md-6 d-flex flex-column justify-content-center position-relative">
                <div
                  className={
                    window.innerWidth <= 992 ? "" : "position-absolute top-0"
                  }
                >
                  <h3 className="">{item.title}</h3>
                  <h4>{item.desc}</h4>
                </div>
                <div
                  className={
                    window.innerWidth <= 992
                      ? "d-flex flex-column justify-content-center"
                      : "d-flex flex-column justify-content-center position-absolute bottom-0"
                  }
                >
                  <div className="d-flex align-items-center">
                    <div className="mt-2 d-flex flex-column align-items-center">
                      <h5>Valor do Pedido IBC:</h5>
                      <h2>{formatIbCash(item.priceIb)}</h2>
                    </div>
                    <i
                      className="fa-solid fa-equals mx-4"
                      style={{ fontSize: "30px", marginTop: "30px" }}
                    ></i>
                    <div className="d-flex flex-column align-items-center">
                      <h5 className="mt-2">Valor do Pedido R$:</h5>
                      <h2 className="text-success">
                        {formatPrice(item.price)}
                      </h2>
                    </div>
                  </div>
                  {balanceIb > item.price ? (
                    <Button
                      rounded
                      type="submit"
                      iconPos="left"
                      label="Solicitar Resgate"
                      icon="fa-solid fa-box-open"
                      className="p-inputtext-sm m-auto mt-4"
                    />
                  ) : (
                    <Button
                      rounded
                      disabled
                      type="submit"
                      iconPos="left"
                      label="Solicitar Resgate"
                      icon="fa-solid fa-box-open"
                      className="p-inputtext-sm m-auto mt-4"
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
        )}
      </Modal>
    </>
  );
};

export default IbCashShop;
